export function estimateTextUsdCost(params: { model: any }) {
  try {
    const { model } = params;
    const provider = (model as any)?.providers?.[0];
    if (!provider || typeof provider.getCost !== 'function') return null;
    const usd = Number(provider.getCost({ input: 0, output: 0 }) ?? 0);
    return Number.isFinite(usd) ? usd : null;
  } catch {
    return null;
  }
}
